export default {
  form: {
    header: {
      label: 'Overskrift',
      placeholder: 'Overskrift',
    },
    discount_badge: {
      label: 'Rabatmærke',
      placeholder: '10 EUR',
    },
    description: {
      label: 'Beskrivelse',
      placeholder: 'Beskrivelse',
    },
    qr_code_header: {
      label: 'Overskrift til UI-boks',
      placeholder: 'Overskrift til UI-boks',
    },
    qr_code_description: {
      label: 'Beskrivelse til UI-boks',
      placeholder: 'Beskrivelse til UI-boks',
    },
    footer: {
      label: 'Fodtekst',
      placeholder: 'Indtast fodtekst',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Vælg URL',
    },
    url: {
      placeholder: 'www.eksempel.dk',
    },
    primary_color: {
      label: 'Primær farve',
    },
    background_color: {
      label: 'Baggrundsfarve',
    },
    cover_image: {
      label: 'Coverbillede',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Flyeren kunne ikke indlæses',
  },
};
